export default "__VITE_ASSET__C1_JX_ae__"